<div class="flex w-full flex-col gap-4 p-6 text-lg text-white/75 sm:p-12">
  <div class="flex w-full flex-col gap-6 md:flex-row">
    <div class="flex max-w-80 flex-col gap-6 md:mr-24">
      <!-- Logo -->
      <img
        ngSrc="wannacamp-logo.png"
        alt="WannaCamp Logo"
        width="76"
        height="70"
        priority
        class="block h-auto w-[64px] object-contain sm:w-[76px]"
      />

      <div>
        {{ 'footer.title' | transloco }}
      </div>

      <!-- Instagram -->
      <a
        class="w-fit rounded-full bg-white/15 p-3"
        href="https://www.instagram.com/wannacamp.it/"
        target="_blank"
        rel="noopener"
      >
        <img
          ngSrc="instagram-brands.svg"
          alt="Instagram Logo"
          width="24"
          height="24"
        />
      </a>
    </div>

    <div
      class="mt-2 grid w-full flex-auto grid-cols-1 gap-12 sm:mt-4 sm:grid-cols-3 md:mt-0 md:gap-16"
    >
      <!-- Navigation -->
      <nav class="flex w-full flex-col gap-5">
        <div class="text-secondary text-lg font-bold uppercase">
          {{ 'footer.discover.title' | transloco }}
        </div>

        @for (discoverItem of discoverItems(); track $index) {
          <a
            class="text-inherit no-underline hover:font-bold hover:text-white sm:tracking-normal"
            [routerLink]="discoverItem.link"
          >
            {{ discoverItem.title | transloco }}
          </a>
        }
      </nav>

      <!-- Navigation -->
      <nav class="flex w-full flex-col gap-5">
        <div class="text-secondary text-lg font-bold uppercase">
          {{ 'footer.support.title' | transloco }}
        </div>

        @for (supportItem of supportItems(); track $index) {
          <a
            class="text-inherit no-underline hover:font-bold hover:text-white sm:tracking-normal"
            [routerLink]="supportItem.link"
          >
            {{ supportItem.title | transloco }}
          </a>
        }
      </nav>

      <!-- Navigation -->
      <nav class="flex w-full flex-col gap-5">
        <div class="text-secondary text-lg font-bold uppercase">
          {{ 'footer.managers.title' | transloco }}
        </div>

        @for (managerItem of managerItems(); track $index) {
          @if (managerItem.externalUrl) {
            <a
              class="cursor-pointer text-inherit no-underline hover:font-bold hover:text-white sm:tracking-normal"
              [href]="managerItem.externalUrl"
              target="_blank"
              rel="noopener"
            >
              {{ managerItem.title | transloco }}
              <span class="sr-only">{{
                'shared.opens_in_new_tab' | transloco
              }}</span>
            </a>
          } @else {
            <a
              class="cursor-pointer text-inherit no-underline hover:font-bold hover:text-white sm:tracking-normal"
              [routerLink]="managerItem.link"
            >
              {{ managerItem.title | transloco }}
            </a>
          }
        }
      </nav>
    </div>
  </div>

  <p-divider />

  <!-- Mandatory company information -->
  <div class="flex w-full flex-col items-center text-center leading-relaxed">
    <span>&copy; {{ currentYear }} Nuove Mete. Tutti i diritti riservati.</span>

    <div>Nuove Mete S.r.l.</div>
    <div>Sede legale: Corso Giuseppe Garibaldi 149, 47121 Forlì (FC)</div>
    <div>C.F. e P.IVA 04756110401</div>
    <div>REA FO-438404</div>
    <div>Capitale sociale € 25.000,00</div>
    <div>
      PEC:
      <a href="mailto:nuovemetesrl&#64;pec.it" class="underline">
        nuovemetesrl&#64;pec.it
      </a>
    </div>
  </div>
</div>
